class DoclrModalService {
    constructor($uibModal, $rootScope) {
        'ngInject';

        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
    }

    openModal(templateUrl, controller, modalContext, modalSize) {
        let backdrop = modalContext ? !!modalContext.backdrop : true;
        const modalInstance = this.$uibModal.open({
            templateUrl: templateUrl,
            resolve: {
                modalContext: modalContext,
            },
            backdrop: backdrop,
            size: modalSize,
            controller: controller,
            controllerAs: 'ModalCtrl'
        });

        if (modalContext && modalContext.onOpened) {
            modalInstance.opened.then(() => modalContext.onOpened());
        }

        return modalInstance.result.then(() => {
        }, () => {
        });
    }

    openEditModal(templateUrl, modalContext) {
        return this.openEditAddModal(templateUrl, modalContext, true)
    }

    openAddModal(templateUrl, modalContext) {
        return this.openEditAddModal(templateUrl, modalContext, false)
    }

    openEditAddModal(templateUrl, modalContext, isEdit) {

        let backdrop = modalContext.backdrop ? modalContext.backdrop : true;
        let modalSize = modalContext.modalSize ? modalContext.modalSize : 'md';

        const scope = modalContext.scope ? modalContext.scope : this.$rootScope.$new(true);

        const modalInstance = this.$uibModal.open({
            templateUrl: templateUrl,
            backdrop: backdrop,
            size: modalSize,
            resolve: {
                modalContext: modalContext,
                isEdit: isEdit
            },
            scope: scope,
            controller: DoclrEditModalCtrl,
            controllerAs: 'editAddModalCtrl',
        });

        if (modalContext && modalContext.onOpened) {
            modalInstance.opened.then(() => modalContext.onOpened());
        }

        return modalInstance.result;
    }


    openOptionModal(title, question, items, selectedItem) {

        const scope = this.$rootScope.$new(true);
        scope.optionModal = {
            title: title,
            question: question,
            selectedItem: selectedItem,
            items: items
        };

        const modalInstance = this.$uibModal.open({
            templateUrl: '/partials/components/modals/option.modal.html',
            scope: scope
        });

        return modalInstance.result.then(function () {
            return scope.optionModal.selectedItem;
        });
    }

    openConfirmModal(title, question) {
        const scope = this.$rootScope.$new(true);
        scope.confirmmodal = {
            title: title,
            question: question
        };

        const modalInstance = this.$uibModal.open({
            templateUrl: '/partials/components/confirmmodal.html',
            scope: scope
        });

        return modalInstance.result;
    }

    openConfirmWithMessageModal(title, question) {
        const scope = this.$rootScope.$new(true);
        scope.confirmmodal = {
            title: title,
            question: question,
            message: null
        };

        const modalInstance = this.$uibModal.open({
            templateUrl: '/partials/components/confirmmodal-with-message.html',
            scope: scope
        });

        return modalInstance.result;
    }
}


(function () {
    'use strict';

    angular.module('doclr.components.util')
        .service('DoclrModalService', DoclrModalService);
})();